import { createReducer, on } from '@ngrx/store';
import { GET_BUSINESS_TYPE } from './business-type.actions';
import { BUSINESS_TYPE } from '../../../model/login';

const initialState: BUSINESS_TYPE[] = [];

export const businessTypeReducer = createReducer(
  initialState,
  on(GET_BUSINESS_TYPE, (state, { payload }) => {
    return payload;
  })
);
